<template>
  <div class="menu-drilldown-menu-list-item">
    <div class="ui-menu-content-item__text ml-8 ml-first-0">
      {{ title }}
    </div>
    <ui-icon
      v-if="hasClose"
      class="menu-drilldown-menu-list-item__icon menu-drilldown-menu-list-item__icon--close ml-8 ml-first-0"
      @click="emit('close', $event)"
      icon="fas fa-times"
    ></ui-icon>
    <ui-icon
      v-else
      class="menu-drilldown-menu-list-item__icon ml-8 ml-first-0"
      icon="fas fa-arrow-to-left"
    ></ui-icon>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title: string;
  hasClose?: boolean;
}>(), {
  hasClose: true,
});

const emit = defineEmits<{
  close: [event: Event];
}>();
</script>

<style lang="scss">
.menu-drilldown-menu-list-item {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  overflow: hidden;

  & &__icon {
    font-size: 13px;
    color: var(--color-graphite);

    &--close {
      color: var(--color-red);
    }
  }
}
</style>
